module.exports = __webpack_public_path__ + "media/application/images/thatGuy-2e382a2d3500eb0ccc39d4414aa9ab0a.jpg";